import { WalletDeposit } from '@bz/wallet';

export const route = {
  info: {
    login: true,
  },
  preload() {
    WalletDeposit.preload?.();
  },
} satisfies RouteDefinition;
export default WalletDeposit;
